import * as T from '../action-types'

// console.log(`types: ${JSON.stringify(T)}`);
export function setViewId(options) {
  return {
    type: T.SET_VIEWID,
    options,
  }
}

export function setAppxigonState(options) {
  return {
    type: T.SET_AXG_STATE,
    options,
  }
}

export function setAppxigonData(options) {
  return {
    type: T.SET_AXG_DATA,
    options,
  }
}

export function setAccountState(options) {
  return {
    type: T.SET_ACCOUNT_STATE,
    options,
  }
}

export function setLoadingState(options) {
  return {
    type: T.SET_LOADING,
    options,
  }
}

export function setSchema(options) {
  return {
    type: T.SET_SCHEMA,
    options,
  }
}

export function resetInput(options) {
  return {
    type: T.RESET_INPUT,
    options,
  }
}

export function signIn(options) {
  return {
    type: T.SIGN_IN,
    options,
  }
}

export function signOut(options) {
  return {
    type: T.SIGN_OUT,
    options,
  }
}

export function setModalViewSchema(options) {
  return {
    type: T.SET_MODAL_VIEW_SCHEMA,
    options,
  }
}

export function setModalTitle(title) {
  return {
    type: T.SET_MODAL_TITLE,
    title,
  }
}

export function setLocale(locale) {
  return {
    type: T.SET_LOCALE,
    locale,
  }
}

export function setAppxigonSchema(schema) {
  return {
    type: T.SET_MODAL_TITLE,
    schema,
  }
}

export function closeModal() {
  return {
    type: T.CLOSE_MODAL
  }
}



// WEBPACK FOOTER //
// ./redux/actions/index.js